import { render, staticRenderFns } from "./OrderCancelledByCustomer.vue?vue&type=template&id=05740d06&"
import script from "./OrderCancelledByCustomer.vue?vue&type=script&lang=js&"
export * from "./OrderCancelledByCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports